//Constantes para almacenar el token en el localStorage const ID_SISTEMA="217"
export const ACCESS_TOKEN="accessToken";
export const REFRESH_TOKEN="refreshToken";
//export const ID_SISTEMA="361" 
//export const ID_SISTEMA="653" //2022
export const ID_SISTEMA="692"
export const UNIDAD_DEOE="DEOE";
export const UNIDAD_JL="JL";
export const UNIDAD_UTVOPL="UTVOPL";
export const UNIDAD_OPL="OPL";